import Drawer from '@mui/material/Drawer';
import { memo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setSidebarOpen } from '../../../redux/slices/uiSlice';
import SidebarNav from './components/SidebarNav/SidebarNav';

const drawerWidth = 280;

const Sidebar = () => {
  const dispatch = useAppDispatch();
  const { sidebarOpen } = useAppSelector(state => state.ui);

  const handleClose = () => {
    dispatch(setSidebarOpen(false));
  };

  return (
    <Drawer
      variant='temporary'
      open={sidebarOpen}
      onClose={handleClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: 'block', md: 'none' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: drawerWidth,
        },
      }}
    >
      <SidebarNav />
    </Drawer>
  );
};

export default memo(Sidebar);
